import { createSelector } from 'reselect'
// import { List } from 'immutable'

const leaveRequestSelector = state => state.get('leaveRequest')

export const getIsFetching = createSelector(
  leaveRequestSelector,
  leaveRequestImmutable => {
    const leaveRequest = leaveRequestImmutable.toJS()
    return leaveRequest.leaveRequestGet.isFetching
    || leaveRequest.leaveRequestApprove.isFetching
    || leaveRequest.leaveRequestPreview.isFetching
    || leaveRequest.leaveRequestCreate.isFetching
    || leaveRequest.leaveRequestCancel.isFetching
  }
)
export const getMyLeaveRequests = createSelector(
  leaveRequestSelector,
  leaveRequestImmutable => {
    const leaveRequest = leaveRequestImmutable.toJS()
    return leaveRequest.leaveRequestGet.leaveRequests
  }
)
export const getLeaveRequestsByGroup = createSelector(
  leaveRequestSelector,
  leaveRequestImmutable => {
    const leaveRequest = leaveRequestImmutable.toJS()
    return leaveRequest.leaveRequestGet.leaveRequests
  }
)
export const getMetaLeaveRequest = createSelector(
  leaveRequestSelector,
  leaveRequestImmutable => {
    const leaveRequest = leaveRequestImmutable.toJS()
    return leaveRequest.leaveRequestPreview
  }
)
export const createLeaveRequestData = createSelector(
  leaveRequestSelector,
  leaveRequestImmutable => {
    const leaveRequest = leaveRequestImmutable.toJS()
    return leaveRequest.leaveRequestCreate
  }
)
export const approveLeaveRequestData = createSelector(
  leaveRequestSelector,
  leaveRequestImmutable => {
    const leaveRequest = leaveRequestImmutable.toJS()
    return leaveRequest.leaveRequestApprove.updatedLeaveRequest
  }
)
export const cancelLeaveRequestData = createSelector(
  leaveRequestSelector,
  leaveRequestImmutable => {
    const leaveRequest = leaveRequestImmutable.toJS()
    return leaveRequest.leaveRequestCancel
  }
)
export const redirectLeaveRequest = createSelector(
  leaveRequestSelector,
  leaveRequestImmutable => {
    const leaveRequest = leaveRequestImmutable.toJS()
    return ({
      redirect: (leaveRequest.leaveRequestGet.redirect
      || leaveRequest.leaveRequestPreview.redirect
      || leaveRequest.leaveRequestCreate.redirect
      || leaveRequest.leaveRequestApprove.redirect
      || leaveRequest.leaveRequestCancel.redirect),
      isAuthenticated: (leaveRequest.leaveRequestGet.isAuthenticated
      || leaveRequest.leaveRequestPreview.isAuthenticated
      || leaveRequest.leaveRequestCreate.isAuthenticated
      || leaveRequest.leaveRequestApprove.isAuthenticated
      || leaveRequest.leaveRequestCancel.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/leave-request/leave-request-selector.js